/* Bundle Tiers — externalized from snippets/bundle-tiers.liquid (logic
   unchanged). Liquid-interpolated data (labels, ordinals, money sample) comes
   from the JSON config block <script type="application/json" data-bt-config>
   rendered next to the picker. */
(function () {
  if (window.__sneakBundleTiersLoaded) return;
  window.__sneakBundleTiersLoaded = true;

  function init() {
    var wrap = document.querySelector('[data-bundle-tiers]');
    if (!wrap || wrap.dataset.btReady) return;
    wrap.dataset.btReady = '1';

    var cfgEl = document.querySelector('[data-bt-config]');
    var cfg = {};
    try { if (cfgEl) cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) {}

    /* Size tip (i) → open the (hidden) size chart drawer, which relocates to <body> on show. */
    var btSizeI = wrap.querySelector('[data-bt-sizechart]');
    if (btSizeI && document.querySelector('[id^="size-chart-overlay-"]')) {
      btSizeI.classList.add('is-clickable');
      btSizeI.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var d = document.querySelector('[id^="size-chart-overlay-"]');
        if (d) { if (d.show) d.show(); else d.setAttribute('open', ''); }
      });
    }

    var baseCompare = parseInt(wrap.dataset.baseCompare, 10) || 0;
    var tiers = Array.prototype.slice.call(wrap.querySelectorAll('[data-bt-tier]'));
    var cards = Array.prototype.slice.call(wrap.querySelectorAll('[data-bt-card]'));
    var built = {}; /* lazily-built size groups, keyed by colour */
    var colorImg = {};
    cards.forEach(function (c) { var im = c.querySelector('img'); colorImg[c.dataset.btColor] = im ? im.src : ''; });
    var panel = wrap.querySelector('[data-bt-panel]');
    var panelColor = wrap.querySelector('[data-bt-panel-color]');
    var summaryEl = wrap.querySelector('[data-bt-summary]');
    var pillEl = wrap.querySelector('[data-bt-pill]');
    var ctaBtn = wrap.querySelector('[data-bt-cta]');
    var ctaLabel = wrap.querySelector('[data-bt-cta-label]');
    var ctaPrice = wrap.querySelector('[data-bt-cta-price]');
    var ctaCompare = wrap.querySelector('[data-bt-cta-compare]');

    var L = cfg.labels || {};
    var ORDINALS = cfg.ordinals || {};
    var ARTICLE = cfg.article;
    var ARTICLE_ETT = cfg.articleEtt;
    var ETT_GARMENTS = (cfg.ettGarments || '').toLowerCase().split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    var GARMENT = cfg.garment;
    var upsellBtn = wrap.querySelector('[data-bt-upsell]');
    var upsellText = wrap.querySelector('[data-bt-upsell-text]');
    /* Currency-aware: derive symbol/placement from the theme's money filter. */
    var _mSample = cfg.moneySample;
    var _mFirst = _mSample.search(/\d/);
    var _mRev = _mSample.split('').reverse().join('').search(/\d/);
    var MONEY_PREFIX = _mFirst < 0 ? '' : _mSample.slice(0, _mFirst);
    var MONEY_SUFFIX = _mRev < 0 ? ' €' : _mSample.slice(_mSample.length - _mRev);
    function money(c) { return MONEY_PREFIX + (c / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + MONEY_SUFFIX; }
    var BADGE = cfg.badge || {};
    function badgeHtml(is48) {
      return is48
        ? '<span class="badge badge--48h"><svg class="badge-48h-icon" aria-hidden="true"><use xlink:href="#48h-icon-badge"></use></svg>' + BADGE.e48 + '</span>'
        : '<span class="badge badge--preorder">' + BADGE.pre + '</span>';
    }
    var L48 = cfg.l48;
    function escAttr(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;'); }
    function escHtml(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

    /* Build one colour's size buttons on demand from /products/{handle}.js
       (shows "…" immediately, fills when the fetch resolves). Cached per colour.
       /products/{handle}.js hides inventory_quantity, so the in-stock (48h)
       badge comes from the Liquid-computed id list on the card; `available`
       still drives the disabled/sold-out state. */
    function buildSizeGroup(color, done) {
      if (built[color]) { done(built[color]); return; }
      var card = cards.filter(function (c) { return c.dataset.btColor === color; })[0];
      if (!card || !panel) { done(null); return; }
      var sg = document.createElement('div');
      sg.className = 'bundle-tiers__sizes';
      sg.setAttribute('data-bt-group', '');
      sg.dataset.btColor = color;
      sg.hidden = true;
      sg.innerHTML = '<span class="bundle-tiers__sizes-loading">…</span>';
      panel.appendChild(sg);
      built[color] = sg;
      done(sg);
      fetch('/products/' + card.dataset.btHandle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var instockIds = (card.dataset.btInstockIds || '').split(',').filter(Boolean);
          var html = '';
          (p.variants || []).forEach(function (v) {
            var purchasable = v.available;
            var inStock = instockIds.indexOf(String(v.id)) !== -1;
            var badge = inStock
              ? '<span class="bundle-tiers__size-badge bundle-tiers__size-badge--48h" title="' + escAttr(L48) + '"><svg class="icon" width="11" height="11"><use xlink:href="#48h-icon"></use></svg></span>'
              : '';
            html += '<button type="button" class="block-swatch bundle-tiers__size' + (purchasable ? '' : ' is-disabled') + '"'
              + ' data-bt-size data-bt-id="' + v.id + '" data-bt-size-label="' + escAttr(v.title) + '"'
              + ' data-bt-instock="' + (inStock ? '1' : '') + '"' + (purchasable ? '' : ' disabled') + '>'
              + badge
              + '<span class="variant-info"><span class="variant-label">' + escHtml(v.title) + '</span></span>'
              + '<span class="bundle-tiers__size-count" data-bt-count></span>'
              + '</button>';
          });
          sg.innerHTML = html;
          render();
        })
        .catch(function () { sg.innerHTML = ''; });
    }

    /* Hide the site sticky add-to-cart / overlay trigger if present */
    ['.product-info__buy-buttons', '[data-purchase-overlay-trigger]'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; });
    });

    /* selections: [{ id, color, size, qty }] */
    var selections = [];
    var upsold = false; /* true once the shopper accepted the tier upsell */
    var tier = null;

    function totalQty() { return selections.reduce(function (n, s) { return n + s.qty; }, 0); }
    function findSel(id) { for (var i = 0; i < selections.length; i++) { if (selections[i].id === id) return selections[i]; } return null; }

    function showPanel(color) {
      if (panelColor) panelColor.textContent = color;
      if (panel) panel.hidden = false;
      cards.forEach(function (c) { c.classList.toggle('is-active', c.dataset.btColor === color); });
      buildSizeGroup(color, function () {
        var sgs = panel ? panel.querySelectorAll('[data-bt-group]') : [];
        Array.prototype.forEach.call(sgs, function (sg) { sg.hidden = sg.dataset.btColor !== color; });
      });
    }
    function hidePanel() {
      if (panel) panel.hidden = true;
      cards.forEach(function (c) { c.classList.remove('is-active'); });
    }

    function addPair(id, color, size, is48) {
      if (!tier || totalQty() >= tier.qty) return;
      var ex = findSel(id);
      if (ex) { ex.qty += 1; } else { selections.push({ id: id, color: color, size: size, qty: 1, e48: is48 }); }
      render();
    }

    function selectTier(el, keepSel) {
      tiers.forEach(function (t) { t.classList.remove('is-selected'); });
      el.classList.add('is-selected');
      tier = {
        qty: parseInt(el.dataset.btQty, 10),
        price: parseInt(el.dataset.btPrice, 10),
        compare: parseInt(el.dataset.btCompare, 10) || 0,
        priceFmt: el.dataset.btPriceFmt || '',
        compareFmt: el.dataset.btCompareFmt || ''
      };
      if (pillEl && el.dataset.btPilltext) pillEl.textContent = el.dataset.btPilltext;
      selections = keepSel || [];
      hidePanel();
      render();
    }

    function render() {
      var need = tier ? tier.qty : 0;
      var total = totalQty();
      var full = total >= need;

      var byColor = {}, byId = {};
      selections.forEach(function (s) {
        byColor[s.color] = (byColor[s.color] || 0) + s.qty;
        byId[s.id] = (byId[s.id] || 0) + s.qty;
      });

      cards.forEach(function (card) {
        var n = byColor[card.dataset.btColor] || 0;
        card.classList.toggle('has-chosen', n > 0);
        var c = card.querySelector('[data-bt-chosen]');
        if (c) c.textContent = n > 0 ? '×' + n : '';
        card.classList.toggle('is-locked', full && n === 0);
      });

      var liveSizeBtns = panel ? panel.querySelectorAll('[data-bt-size]') : [];
      Array.prototype.forEach.call(liveSizeBtns, function (b) {
        var n = byId[parseInt(b.dataset.btId, 10)] || 0;
        b.classList.toggle('is-active-qb', n > 0);
        var cnt = b.querySelector('[data-bt-count]');
        if (cnt) cnt.textContent = n > 1 ? n : '';
      });

      if (summaryEl) {
        if (!selections.length) {
          summaryEl.hidden = true;
          summaryEl.innerHTML = '';
        } else {
          summaryEl.hidden = false;
          summaryEl.innerHTML = selections.map(function (s, i) {
            var img = colorImg[s.color] || '';
            return '<div class="bundle-tiers__chip">' +
                (img ? '<img class="bundle-tiers__chip-img" src="' + img + '" alt="" width="48" height="48" loading="lazy">' : '') +
                '<span class="bundle-tiers__chip-text">' +
                  '<span class="bundle-tiers__chip-color">' + s.color + '</span>' +
                  '<span class="bundle-tiers__chip-meta">' +
                    '<span class="bundle-tiers__chip-size">' + s.size + '</span>' +
                    badgeHtml(s.e48) +
                  '</span>' +
                '</span>' +
                '<span class="bundle-tiers__stepper">' +
                  '<button type="button" class="bundle-tiers__stepper-btn" data-bt-dec="' + i + '" aria-label="−">−</button>' +
                  '<span class="bundle-tiers__stepper-qty">' + s.qty + '</span>' +
                  '<button type="button" class="bundle-tiers__stepper-btn" data-bt-inc="' + i + '"' + (full ? ' disabled' : '') + ' aria-label="+">+</button>' +
                '</span>' +
              '</div>';
          }).join('');
        }
      }

      var compareTotal = tier ? tier.compare : 0;
      var priceTotal = tier ? tier.price : 0;
      if (ctaCompare) ctaCompare.textContent = (compareTotal > priceTotal) ? tier.compareFmt : '';
      if (ctaPrice) ctaPrice.textContent = priceTotal ? tier.priceFmt : '';
      var points = wrap.querySelector('sneak-points');
      if (points && points.setAmount) points.setAmount(priceTotal);

      if (full && need > 0) {
        ctaBtn.disabled = false;
        ctaLabel.textContent = L.cta;
      } else {
        ctaBtn.disabled = true;
        ctaLabel.textContent = L.colors + ' (' + total + '/' + need + ')';
      }
      updateUpsell();
    }

    /* Tier selection */
    tiers.forEach(function (t) { t.addEventListener('click', function () { upsold = false; selectTier(t); }); });

    /* ── Tier upsell: nudge to the next pack once the current is full ───── */
    function nextTierEl(qty) {
      for (var i = 0; i < tiers.length; i++) {
        if (parseInt(tiers[i].dataset.btQty, 10) === qty + 1) return tiers[i];
      }
      return null;
    }
    function updateUpsell() {
      if (!upsellBtn) return;
      var nxt = tier ? nextTierEl(tier.qty) : null;
      var marginal = nxt ? ((parseInt(nxt.dataset.btPrice, 10) || 0) - tier.price) : 0;
      var full = tier && totalQty() >= tier.qty;
      if (!nxt || marginal <= 0 || !full) { upsellBtn.hidden = true; upsellBtn._target = null; return; }
      var nextQty = parseInt(nxt.dataset.btQty, 10);
      var ord = ORDINALS[String(nextQty)] || '';
      var article = ETT_GARMENTS.indexOf(GARMENT) !== -1 ? ARTICLE_ETT : ARTICLE;
      var priceHtml = '<span class="bundle-deals__upsell-price">' + money(marginal) + '</span>';
      upsellBtn._target = nxt;
      if (upsellText) upsellText.innerHTML = L.addMore
        .replace('#ART#', article).replace('#ORD#', ord).replace('#GAR#', GARMENT).replace('#PRICE#', priceHtml)
        .replace(/\s+/g, ' ').trim();
      upsellBtn.hidden = false;
    }
    if (upsellBtn) {
      upsellBtn.addEventListener('click', function () {
        var nxt = upsellBtn._target;
        if (!nxt) return;
        /* Keep picks, move up a pack, and re-open the size picker on the last
           chosen colour so they pick the extra pair's size. */
        selectTier(nxt, selections);
        upsold = true;
        var last = selections[selections.length - 1];
        if (last) showPanel(last.color);
      });
    }

    /* Clicks: panel open/close, size add, stepper */
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-bt-panel-close]')) { hidePanel(); return; }

      var inc = e.target.closest('[data-bt-inc]');
      if (inc) { if (tier && totalQty() < tier.qty) { selections[parseInt(inc.dataset.btInc, 10)].qty += 1; render(); } return; }

      var dec = e.target.closest('[data-bt-dec]');
      if (dec) {
        var di = parseInt(dec.dataset.btDec, 10);
        selections[di].qty -= 1;
        if (selections[di].qty <= 0) selections.splice(di, 1);
        render();
        return;
      }

      var sizeBtn = e.target.closest('[data-bt-size]');
      if (sizeBtn) {
        if (sizeBtn.disabled) return;
        var g = sizeBtn.closest('[data-bt-group]');
        var sizeId = parseInt(sizeBtn.dataset.btId, 10);
        /* Single-pair tiers behave like a radio: clicking a different size
           switches to it (instead of being blocked once the pair is chosen);
           clicking the already-chosen size clears it. Multi-pair tiers keep the
           additive behaviour and use the summary steppers to adjust. */
        if (tier && tier.qty === 1) {
          var already = findSel(sizeId);
          selections = [];
          if (already) { render(); return; }
        }
        addPair(sizeId, g.dataset.btColor, sizeBtn.dataset.btSizeLabel, sizeBtn.dataset.btInstock === '1');
        return;
      }

      var card = e.target.closest('[data-bt-card]');
      if (!card) return;
      if (card.classList.contains('is-locked')) return;
      if (card.classList.contains('is-active')) { hidePanel(); return; }
      showPanel(card.dataset.btColor);
    });

    /* Final add to cart */
    ctaBtn.addEventListener('click', function () {
      if (!tier || totalQty() < tier.qty) return;

      var qtyById = {};
      var outOfStock = {};
      selections.forEach(function (s) {
        qtyById[s.id] = (qtyById[s.id] || 0) + s.qty;
        if (!s.e48) outOfStock[s.id] = true;
      });

      /* No line properties: the volume discount Function reads the tiers from
         product.metafields.custom.bundle_tiers and computes the discount
         automatically from the quantity in cart. (The cross-product mix & match
         bundles still stamp _bundle_final_price in their OWN snippets — those
         must not change; this Slide picker deliberately omits it.) */
      var items = Object.keys(qtyById).map(function (id) {
        var item = { id: parseInt(id, 10), quantity: qtyById[id] };
        if (upsold) item.properties = { _bundle_upsell: 'true' };
        /* Out-of-stock picks are preorders: mark them for the payment rules at
           checkout (the cart reconciler double-checks every line). */
        if (outOfStock[id] && window.sneakPreorder) item.properties = window.sneakPreorder.stampProps(item.properties);
        return item;
      });

      ctaBtn.disabled = true;
      ctaBtn.style.opacity = '0.6';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var drawer = document.getElementById('cart-drawer');
          if (drawer && drawer.show) drawer.show();
          selectTier(wrap.querySelector('[data-bt-tier].is-selected') || tiers[0]);
        })
        .catch(function (err) { console.error('BundleTiers ATC error', err); })
        .finally(function () { ctaBtn.style.opacity = ''; });
    });

    /* boot with the default-selected tier */
    var pre = wrap.querySelector('[data-bt-tier].is-selected') || tiers[0];
    if (pre) selectTier(pre);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
  /* Re-init after Section Rendering API swaps (injected scripts don't run);
     the wrap-level btReady flag keeps this idempotent. */
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 100); });
})();
